
    const _each = require("lodash/each");
    const _times = require("lodash/times");
    const _escape = require("lodash/escape");
    const _throttle = require("lodash/throttle");

    const _ = {
        each: _each,
        times: _times,
        escape: _escape,
        throttle: _throttle,
    };

    module.exports = function(context) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div is="slide-indicators" class="image-gallery__slide-indicators';
 if (context.hidden) { ;
__p += ' hidden';
 } ;
__p += '"><div class="slide-indicators ';
 if (context.alternativeActiveHighlight) { ;
__p += 'slide-indicators--alternative';
 } ;
__p += '"><span class="fullscreen-overlay-indicators-inner">';
 _.times(context.maxSlides, function(idx) { ;
__p += '<span class="slide-indicators__indicator';
 if (idx === context.selectedIndex) { ;
__p += ' slide-indicators__indicator--active';
 } ;
__p += '" data-index="' +
__e( idx ) +
'"></span>';
 }) ;
__p += '</span></div></div>';
return __p
};
    